import { ZONES_BUNDLE } from '@auctionradar/shared';

/**
 * Resolve a zone slug → its Greek display name via the bundled taxonomy.
 * Falls back to a title-cased slug (handles the legacy `athens-` prefix) when
 * the slug isn't in the bundle, and to null when there's no slug at all.
 */
export function zoneNameEl(slug: string | null | undefined): string | null {
  if (!slug) return null;
  const idx = ZONES_BUNDLE.by_slug[slug];
  const z = idx != null ? ZONES_BUNDLE.zones[idx] : null;
  if (z?.name_el) return z.name_el;
  return slug
    .replace(/^athens-/, 'Αθήνα · ')
    .split('-')
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(' ');
}
